import { FC } from 'react';
import { ProductComparisonBlockStoryblok } from 'storyblok-types';
import { getProductsByParentReferenceKeys } from 'commerce/scayle/product-management';
import { ProductComparisonBlockBody } from './ProductComparisonBlockBody';

export const ProductComparisonBlock: FC<{
  blok: ProductComparisonBlockStoryblok;
}> = async ({ blok }) => {
  const productIds = blok.products.map(({ id }) => id);
  const { response: products, error } = await getProductsByParentReferenceKeys(
    productIds || [],
  );

  if (error) {
    console.error(error);
    return;
  }

  /** reverse() need to keep the order of products as in the Storyblok */
  const productsWithStoyblokData = products?.toReversed()?.map((product) => {
    const relevantProduct = blok.products.find(
      ({ id }) => product.referenceKey === id,
    );

    return {
      ...product,
      productName: relevantProduct?.name,
      productImage: relevantProduct?.image,
      options: relevantProduct?.options,
    };
  });

  return (
    <ProductComparisonBlockBody
      blok={blok}
      products={productsWithStoyblokData}
    />
  );
};
